import { JwtHelperService } from '@auth0/angular-jwt';

import { Authority } from './authority.model';
import { JWT } from './jwt.model';

const PATH_FILE = 'app/shared/jwt/token.model.ts';

export class Token {
	encoded: string;
	decoded: JWT;
	authorities: Set<string>;
	createDate: Date;
	expireDate: Date;
	isExpired: boolean;

	constructor(token: string, public jwtHelper: JwtHelperService) {
		this.encoded = token;
		this.decoded = this.jwtHelper.decodeToken(token);
		this.createDate = this.tokenCreateDate();
		this.expireDate = this.tokenExpireDate();
		this.extractAuthorities();
	}

	private extractAuthorities() {
		this.authorities = new Set<string>();
		let kernrecht: Array<Authority> = this.decoded.at_oase_authorities;
		if (kernrecht != null) {
			for (const currentRecht of kernrecht) {
				this.authorities.add(currentRecht.authority);
			}
		}
	}

	private tokenCreateDate(): Date {
		// Code von this.jwtHelper.getTokenExpirationDate kopiert
		if (this.decoded == null || !this.decoded?.hasOwnProperty('iat')) {
			return null;
		}
		let date = new Date(0); // The 0 here is the key, which sets the date to the epoch
		date.setUTCSeconds(this.decoded.iat);
		return date;
	}

	private tokenExpireDate(): Date {
		if (this.encoded == null) {
			return new Date();
		}
		return this.jwtHelper.getTokenExpirationDate(this.encoded);
	}

	public isTokenExpired(): boolean {
		if (this.encoded == null) {
			return true;
		}
		return this.expireDate.getTime() < new Date().getTime();
		//    return this.jwtHelper.isTokenExpired(this.encoded);
	}
}